import React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 250,
    margin: "10px 23px 5px 5px",
    padding: theme.spacing(2),
    // height: "10rem",
  },
}));

const CountCard = ({ title, count, icon, backgroundColor, gradientColor }) => {
  const classes = useStyles();

  return (
    <div
      style={{
        marginTop: 20,
        width: 260,
        height: 121,
        color: "white",
        borderRadius: 5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
        background: backgroundColor,
        background: gradientColor,
      }}
    >
      <Grid>
        <Typography style={{ fontSize: 23, marginLeft: 8, marginBottom: 7 }}>
          {title}
        </Typography>
        <Typography
          style={{
            fontSize: 28,
            fontWeight: "bold",
            marginLeft: 8,
            marginBottom: 16,
          }}
        >
          {count}
        </Typography>
      </Grid>
      <Grid style={{ marginRight: 9 }}>{icon}</Grid>
    </div>
  );
};

export default CountCard;
